import { useState } from 'react'
import styled from 'styled-components'
import config from '../../../../config'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'

const FindUserCard = ({ onUserFound }) => {
  const [loading, setLoading] = useState(false)

  const handleSearchUser = async (e) => {
    e.preventDefault()
    const userNo = e.target.elements.userNo.value

    if (!userNo) return

    try {
      setLoading(true)

      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/users?userId=${userNo}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error(response.status.description)

      const userData = response.data?.[0]

      if (!userData) throw new Error('ไม่พบข้อมูลลูกค้า')

      const kycResponse = await fetch(`${config.apiAdminGateway}/api/v1/admin/users?userId=${userNo}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((res) => res.json())

      if (kycResponse.status.code !== 0) throw new Error(kycResponse.status.description)

      onUserFound(userData)
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'ไม่พบข้อมูล',
        text: 'กรุณาลองใหม่อีกครั้ง',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <StyledForm onSubmit={handleSearchUser}>
      <StyledHeaderText>ค้นหารหัสลูกค้าเพื่อทำการยืนยันตัวตน</StyledHeaderText>
      <StyledInput type="text" id="userNo" placeholder="กรุณากรอกรหัสลูกค้า" />
      <button className="btn btn-primary" type="submit" disabled={loading}>
        ค้นหา
      </button>
    </StyledForm>
  )
}

const StyledHeaderText = styled.span`
  font-size: 1.25rem;
  font-weight: bold;
  text-align: center;
`

const StyledForm = styled.form`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
`

const StyledInput = styled.input`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 8cap;
  width: 100%;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #007bff;
  }

  &::placeholder {
    color: #ccc;
  }
`

export default FindUserCard
